// extracted by mini-css-extract-plugin
export default {"container":"UserSelectField_container__tJrdz","avatar":"UserSelectField_avatar__h0rnb","allUsersIcon":"UserSelectField_allUsersIcon__3Bp8w"};